import { Box, Grid } from '@mui/material';
import { AdminServiceStatus, ServiceUptimeDataPoint, ResponseTimeDataPoint } from '../../../types/admin';
import RefreshButton from './shared/RefreshButton';
import ServiceStatusCard from './service-status/ServiceStatusCard';
import ServiceUptimeChart from './service-status/ServiceUptimeChart';
import ResponseTimeChart from './service-status/ResponseTimeChart';

interface ServiceStatusTabProps {
  services: AdminServiceStatus[];
  uptimeHistory: ServiceUptimeDataPoint[];
  responseTimeHistory: ResponseTimeDataPoint[];
  loading?: boolean;
  lastUpdated: string;
  onRefresh: () => void;
}

export default function ServiceStatusTab({
  services,
  uptimeHistory,
  responseTimeHistory,
  loading,
  lastUpdated,
  onRefresh,
}: ServiceStatusTabProps) {
  return (
    <Box>
      {/* Header with Refresh Button */}
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 3 }}>
        <RefreshButton onRefresh={onRefresh} lastUpdated={lastUpdated} loading={loading} />
      </Box>

      {/* Service Status Cards */}
      <Grid container spacing={3} sx={{ mb: 4 }}>
        {services.map((service) => (
          <Grid item xs={12} md={6} lg={4} key={service.service}>
            <ServiceStatusCard service={service} />
          </Grid>
        ))}
      </Grid>

      {/* Charts */}
      <Grid container spacing={3}>
        <Grid item xs={12} lg={6}>
          <ServiceUptimeChart data={uptimeHistory} loading={loading} />
        </Grid>
        <Grid item xs={12} lg={6}>
          <ResponseTimeChart data={responseTimeHistory} loading={loading} />
        </Grid>
      </Grid>
    </Box>
  );
}
